module.exports = __webpack_public_path__ + "img/default_foto_gp.4c70a36b.png";